import dayjs from "dayjs"
import clsx from "clsx"

import Table from "@/ui/components/Table"
import { Checkbox } from "@/ui/components/Checkbox"
import { spacedNum } from "@/components/common/CommonHelper"

import type { BalanceHistoryItem } from "@/types/balances"
import type { FC } from "react"

import style from "@/components/manager/balance/style.module.scss"

type Props = {
  item: BalanceHistoryItem
  isChecked: boolean
  handleCheckboxChange: (id: number, value: boolean) => void
}

export const InvoicesItem: FC<Props> = ({ item, isChecked, handleCheckboxChange }) => {
  return (
    <Table.Item className={clsx(style.historyTableRow, style.historyTableRowItem)}>
      <div>
        <Checkbox checked={isChecked} onChange={value => handleCheckboxChange(item.id, value)} />
      </div>
      <div>{item.stmtDate ? dayjs(item.stmtDate).format("DD.MM.YYYY") : "-"}</div>
      <div>{item.dc ? spacedNum(item.dc / 100) : "-"}</div>
      <div>{item.operationType || "-"}</div>
      <div>{item.description || "-"}</div>
      <div>{item.accountNumber || "-"}</div>
      <div>{item.bank?.currency || "-"}</div>
      <div>{item.contractor || "-"}</div>
      <div>{item.bank?.swift || "-"}</div>
      <div>{item.bank?.name || "-"}</div>
      <div>{item.owner || "-"}</div>
    </Table.Item>
  )
}
